import { api } from './client';

export interface AdDataFreshness {
  supported: boolean;
  platform: string;
  updated_at: string;
}
export function fetchAdDataFreshness(params: { brand_id: string; site_id: string; platform: string }, signal: AbortSignal) {
  return api.get<{ code: number; data: AdDataFreshness }>('/ad-dashboard/freshness', { params, signal, timeout: 15000 })
    .then(response => {
      if (response.code !== 0) throw new Error('更新时间暂不可用');
      return response.data;
    });
}
